const fetch = () => {
  return Promise.resolve()
}


export default {
  fetch,
}
